(function() {
    'use strict';

    angular.module('process')
        .controller('ProductionCubeProductStatusController', ProductionCubeProductStatusController);

    ProductionCubeProductStatusController.$inject = ['products', 'status', '$uibModalInstance', 'notificationSrvc', 'orderProductProcessStageStatusMessagesConst', 'productionCubeStatusConst', 'orderProductProcessStageStatusDataSrvc', 'errorNotificationSrvc'];

    function ProductionCubeProductStatusController(products, status, $uibModalInstance, notificationSrvc, orderProductProcessStageStatusMessagesConst, productionCubeStatusConst, orderProductProcessStageStatusDataSrvc, errorNotificationSrvc) {
        var self = this;

        self.data = {
            info: null,
            selectedCheckboxes: {}
        };
        self.checkboxes = [];
        self.isStarting = isStarting;
        self.isEnding = isEnding;
        self.saving = false;

        self.ok = ok;
        self.close = close;

        activate();

        function activate() {
            getCheckboxes();
        }

        function isStarting() {
            return status === productionCubeStatusConst.started;
        }

        function isEnding() {
            return status === productionCubeStatusConst.finished;
        }

        function getCheckboxes() {
            if (self.isStarting()) {
                self.checkboxes = products[0].process_stage.machine_action.checklist_before_start;
            } else if (self.isEnding()) {
                self.checkboxes = products[0].process_stage.machine_action.checklist_before_end;
            }
        }

        function ok() {
            self.saving = true;
            var data = [];
            angular.forEach(products, function (product) {
                data.push({
                    order_product: product.pk,
                    process_stage: product.process_stage.pk,
                    status: status,
                    info: self.data.info,
                    checklist: Object.keys(self.data.selectedCheckboxes)
                });
            });

            orderProductProcessStageStatusDataSrvc.create(
                data
            ).$promise.then(
                function(response) {
                    self.close(true);

                    if (self.isStarting()) {
                        notificationSrvc.notification("success", orderProductProcessStageStatusMessagesConst.addStart);
                    } else if (self.isEnding()) {
                        notificationSrvc.notification("success", orderProductProcessStageStatusMessagesConst.addFinish);
                    }

                    self.saving = false;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.saving = false;
                }
            );
        }

        function close(isCreated) {
            $uibModalInstance.close(isCreated);
        }
    }
})();
